import { render, staticRenderFns } from "./renja_setup.vue?vue&type=template&id=47b31722&"
import script from "./renja_setup.vue?vue&type=script&lang=js&"
export * from "./renja_setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports